export enum IncomeType {
  W2 = 'W2',
  SocialSecurity = 'Social Security',
  VADisability = 'VA Disability',
  MilitaryPension = 'Military Pension',
}
